import React from 'react'

import { Table, TableRow } from '../../../../../components/pdf/Table'
import { TableHeadText, TableColText, TableColLabelValue } from '../../../../../components/pdf/TableHelpers'
import Separator from '../../../../../components/pdf/Separator'
import Text from '../../../../../components/pdf/Text'
import Bar from '../../../../../components/pdf/Bar'
import View from '../../../../../components/pdf/View'
import {
  toCurrency,
  findReplyByQuestionName,
  findReplyByQuestionId,
  filterRepliesByParentReference,
  currencyToNumber,
  getFieldValue,
  mountAssetsValues
} from '../../_helpers/pdfHelpers'
import { useMemo } from 'react'
import { useAssetsFieldValues } from '../../_load/AssetsFieldValuesLoader'
import { useServiceOrder } from '../../_load/ServiceOrderLoader'
import { useParentServiceOrder } from '../../_load/ParentServiceOrderLoader'

const BudgetVivoManual = () => {
  const mainServiceOrder = useServiceOrder()
  const parentServiceOrder = useParentServiceOrder()

  const serviceOrder = parentServiceOrder || mainServiceOrder
  const assetsFieldValues = useAssetsFieldValues()

  const parentAssets = useMemo(() => {
    const mainAssetReply = findReplyByQuestionName(parentServiceOrder.replies, 'Equipamentos trocados')
    const assets = filterRepliesByParentReference(parentServiceOrder.replies, mainAssetReply.question.reference)
    const assetsValues = mountAssetsValues(assets)
    const assetsData = []
    assetsValues.forEach(asset => {
      const id = asset.id
      const assetName = asset['Equipamento']
      const qtd = asset['Quantidade']

      const fields = assetsFieldValues.find(assetsFieldValues => assetsFieldValues.id === id)
      if (!fields || !fields.fieldValues) {
        return
      }

      const assetValue = getFieldValue(fields, 'Valor do equipamento (R$) 2')
      const workHourValue = getFieldValue(fields, 'Valor da mão de obra (R$)')
      const fieldInternalCode = getFieldValue(fields, 'CÓD. ITEM')
      const internalCode = fieldInternalCode ? fieldInternalCode.value : ''
      assetsData.push({
        internalCode,
        codEquip: internalCode,
        description: assetName,
        qtd: Number(qtd),
        unitPrice: currencyToNumber(assetValue ? assetValue.value : 0),
        workHour: currencyToNumber(workHourValue ? workHourValue.value : 0)
      })
    })

    return assetsData
  }, [parentServiceOrder, assetsFieldValues])

  const mainAssets = useMemo(() => {
    const mainAssetReply = findReplyByQuestionName(mainServiceOrder.replies, 'Equipamento')
    const assets = filterRepliesByParentReference(mainServiceOrder.replies, mainAssetReply.question.reference)
    const assetsValues = mountAssetsValues(assets)
    const assetsData = []
    assetsValues.forEach(asset => {
      const assetName = asset['Nome do Equipamento']
      const qtd = asset['Quantidade']

      const assetValue = asset['Valor do equipamento']
      const workHourValue = 0
      const fieldInternalCode = ''
      const internalCode = fieldInternalCode ? fieldInternalCode.value : ''
      assetsData.push({
        internalCode,
        codEquip: internalCode,
        description: assetName,
        qtd: Number(qtd),
        unitPrice: currencyToNumber(assetValue ? assetValue : 0),
        workHour: currencyToNumber(workHourValue ? workHourValue.value : 0)
      })
    })

    return assetsData
  }, [mainServiceOrder])

  const assetsData = useMemo(() => {
    return mainAssets.concat(parentAssets)
  }, [mainAssets, parentAssets])

  const sumTotalAssets = () => {
    const total = {
      totalQtd: 0,
      totalUnitPrice: 0,
      sumWorkHour: 0,
      totalWorkHour: 0,
      total: 0
    }
    assetsData.forEach(eqp => {
      total.totalQtd += eqp.qtd
      total.totalUnitPrice += eqp.unitPrice
      total.total += eqp.qtd * eqp.unitPrice
      total.sumWorkHour += eqp.workHour
      total.totalWorkHour += eqp.qtd * eqp.workHour
    })
    return total
  }

  const assetsummary = sumTotalAssets()

  // const acceptanceItens = useMemo(() => {
  //   return {
  //     orderNumber: findReplyByQuestionId(parentServiceOrder.replies, 15506).value,
  //     item: findReplyByQuestionId(parentServiceOrder.replies, 15507).value
  //   }
  // }, [parentServiceOrder])

  return (
    <View>
      <Text bold size="h4" align="left">
        Fatura - Equipamentos
      </Text>
      <Table justify="space-between" width={'100%'}>
        <TableRow>
          <TableHeadText align="center">Cod. Interno</TableHeadText>
          <TableHeadText align="center">Cod. Equip.</TableHeadText>
          <TableHeadText align="center">Descrição</TableHeadText>
          <TableHeadText align="center">Qtd</TableHeadText>
          <TableHeadText align="center">Preço Unitário</TableHeadText>
          <TableHeadText align="center">Preço Total</TableHeadText>
        </TableRow>
        {assetsData?.map((row, rowIndex) => (
          <TableRow key={rowIndex}>
            <TableColText align="center">{row.internalCode}</TableColText>
            <TableColText align="center">{row.codEquip}</TableColText>
            <TableColText align="center">{row.description}</TableColText>
            <TableColText align="center">{row.qtd}</TableColText>
            <TableColText align="center">{toCurrency(row.unitPrice)}</TableColText>
            <TableColText align="center">{toCurrency(row.qtd * row.unitPrice)}</TableColText>
          </TableRow>
        ))}
        <TableRow>
          <TableHeadText align="center" colSpan={3}>
            Total
          </TableHeadText>
          <TableHeadText align="center">{assetsummary.totalQtd}</TableHeadText>
          <TableHeadText align="center">{toCurrency(assetsummary.totalUnitPrice)}</TableHeadText>
          <TableHeadText align="center">{toCurrency(assetsummary.total)}</TableHeadText>
        </TableRow>
      </Table>

      <Separator weight={4} />

      <>
        <Text bold size="h4" align="right">
          Total: {toCurrency(assetsummary.total)}
        </Text>
        <Separator weight={4} />
        <Bar />
      </>
    </View>
  )
}

export default BudgetVivoManual
